import { Component, OnInit,ViewChild } from '@angular/core';
import { loadMessages } from 'devextreme/localization';
import { TranslateService } from '@ngx-translate/core';
import { genericCustomStoreService } from 'src/app/shared/services/genericCustomStore.service';
import { ObjectsService } from 'src/app/shared/services/hr/objects.service';
import { SalaryService } from '../../../../shared/services/hr/salary.service';
import { AttendingLeavingService } from '../../../../shared/services/hr/attending-leaving.service';
import { DxDataGridComponent } from 'devextreme-angular';
import { GeneralCalcSalaryInputsComponent } from '../../general-calc-salary-inputs/general-calc-salary-inputs.component';

@Component({
  selector: 'app-attending-leaving-data',
  templateUrl: './attending-leaving-data.component.html',
  styleUrls: ['./attending-leaving-data.component.scss']
})
export class AttendingLeavingDataComponent implements OnInit {
  button={}
  customDataSource:any;
  employeeDropDown:[];
  durationWorkSystemDropDown:[];
  workSystemdropdown:[]=[]
  attendanceChnnged:number;
  Attending_Leaving:any;
  processedData: any[] = [];
  filterFormData: any = {};
  iteration:number=1
  LOCALIZATION_LOCAL_STORAGE_KEY = "Language";
  currentLang:any;
  @ViewChild('dataGridVar', { static: false }) dataGrid: DxDataGridComponent;
  @ViewChild(DxDataGridComponent) grid: DxDataGridComponent;
  @ViewChild('salaryInputs', { static: false }) salaryInputsComponent: GeneralCalcSalaryInputsComponent;
  constructor(public ObjectsService:ObjectsService,public translate:TranslateService,
    public AttendingLeavingService:AttendingLeavingService,
    public gt: genericCustomStoreService,public SalaryService:SalaryService) {
    this.button=ObjectsService.button;
    this.Attending_Leaving=ObjectsService.Attending_Leaving 
    gt.getdropdowndata("Employee").subscribe((res:any)=>{
      // this.employeeDropDown=res.data;
      this.employeeDropDown=res;
    })

    gt.getdropdowndata("DurationWorkSystem").subscribe((res:[])=>{
      this.durationWorkSystemDropDown=res
    })
  
    this.attendanceChange=this.attendanceChange.bind(this)
    this.currentLang = localStorage.getItem(
      this.LOCALIZATION_LOCAL_STORAGE_KEY
    );

    loadMessages({
      en: { "Yes": this.translate.instant('personal.yes'), "No": this.translate.instant('personal.no') }
  });
  }

ngOnInit(): void {
  // this.AttendingLeavingService.submit('Attending_Leaving');
  
  // // ✅ اشترك في البيانات وادمجها فور ما تيجي
  // this.AttendingLeavingService.customDataSource.load().then((data: any[]) => {
  //   this.customDataSource = this.processAttendanceData(data);
  // });
}
onFormDataChanged(formData: any): void {
    this.filterFormData = formData;
  }

resetFilter(): void {
    if (this.salaryInputsComponent) {
      this.salaryInputsComponent.resetForm();
      this.filterFormData = {};
      this.customDataSource = []; // تصفير الجدول
    }
  }
  prepareRequestData(formData: any): any {
    const formatDate = (date: any): string | null => {
      if (!date) return null;
      if (date instanceof Date) return date.toISOString();
      return new Date(date).toISOString();
    };

    return {
      FromDate: formatDate(formData.fromDate),
      ToDate: formatDate(formData.toDate),
      EmployeeIds: formData.employeeIds || [],
      JobTitleIds: formData.jobTitleIds || [],
      DepartmentIds: formData.departmentIds || [],
      WorkSystemIds: formData.workSystemIds || [],
      ManagementIds: formData.managementIds || [],
      BranchIds: formData.branchIds || [],
      // أي حقول إضافية يحتاجها الـ API الخاص بك
    };
  }
applyFilter(): void {
    // سحب البيانات من المكون الابن
    const filterData = this.salaryInputsComponent.getFormData();
    
    // تحويل البيانات لشكل يفهمه الـ API
    const requestData = this.prepareRequestData(filterData);
    
    console.log('Sending Filter Request:', requestData);

    // استدعاء الـ API الخاص بالحضور والانصراف
    // ملاحظة: تأكد أن الخدمة AttendingLeavingService لديها دالة تتعامل مع الـ Filter
    this.AttendingLeavingService.getAttendanceWithFilter(requestData).subscribe({
      next: (res: any) => {
        // دمج البيانات (Flattening) باستخدام الدالة الموجودة عندك
        this.customDataSource = this.processAttendanceData(res.data || res);
        
        if (this.dataGrid) {
          this.dataGrid.instance.refresh();
        }
      },
      error: (err) => {
        console.error('Error fetching filtered data', err);
      }
    });
  }

dataChange(event: any) {
  if (event == 'all') {
    this.AttendingLeavingService.submit('Attending_Leaving');
    this.AttendingLeavingService.customDataSource.load().then((data: any[]) => {
      this.customDataSource = this.processAttendanceData(data);
    });
  } else {
    this.customDataSource = this.processAttendanceData(event.data);
  }
}
  formatTime(rowData: any): string {
  if (!rowData.timeAttending) return '';
  // لو string زي "21:07:00" خد أول 5 حروف بس
  return rowData.timeAttending.substring(0, 5);
}

formatTimeLeave(rowData: any): string {
  if (!rowData.timeLeave) return '';
  return rowData.timeLeave.substring(0, 5);
}
  updateRow(options:any) {  
  if(options.newData.timeAttending){options.oldData.time=options.newData.timeAttending;delete options.newData.timeAttending}
  if(options.newData.timeLeave){options.oldData.time=options.newData.timeLeave;delete options.newData.timeLeave}
    options.newData = Object.assign(options.oldData, options.newData);
  }
  onInitNewRow(e:any){
  e.data.dateOfDay=new Date()
  e.data.attending_LeavingType=1
  this.attendanceChnnged=1;
  this.iteration=1
  }
  onEditingStart(e:any){
    if(e.data.attending_LeavingType==2){
     e.data.time2=e.data.time
     delete e.data.time
    }
    this.iteration=2
  }

  onEditCanceling(){
    this.dataGrid.instance.refresh()
  }

 
  onEditorPreparing(e:any) {
    if ((e.dataField === "time" || e.dataField === "timeAttending") && e.parentType === "dataRow") {      
        e.editorOptions.disabled = e.row.data && e.row.data.attending_LeavingType == 2; 
         
    }
    if ((e.dataField === "time2" || e.dataField === "timeLeave") && e.parentType === "dataRow") {
      e.editorOptions.disabled = e.row.data && e.row.data.attending_LeavingType == 1; 
      
  }
}




attendanceChange(newData:any,value:number){
  newData.attending_LeavingType=value
  this.attendanceChnnged=value
}


addrowfun(name:string){
  return this.gt.addrow(name)
}

// دالة لدمج البيانات
processAttendanceData(rawData: any[]): any[] {
  const grouped: { [key: string]: any } = {};

  for (const curr of rawData) {
    const dateKey = curr.dateOfDay ? curr.dateOfDay.split('T')[0] : 'no-date';
    const key = `${curr.employeeId}_${dateKey}`;

    if (!grouped[key]) {
      grouped[key] = {
        id: curr.id,
        employeeId: curr.employeeId,
        employeeName: curr.employeeName,
        dateOfDay: dateKey,          // ✅ "2026-04-23" string نظيف
        durationWorkSystemId: curr.durationWorkSystemId,
        durationName: curr.durationName,
        timeAttending: null,
        timeLeave: null,
        description: curr.description
      };
    }

    // ✅ خزّن الوقت string مباشرة
    if (curr.attending_LeavingType === 1) {
      grouped[key].timeAttending = curr.time ? curr.time.substring(0, 5) : 'لم يتم بصم حضور'; // "21:07"
    } else if (curr.attending_LeavingType === 2) {
      grouped[key].timeLeave = curr.time ? curr.time.substring(0, 5) : 'لم يتم بصم انصراف';     // "16:43"
    }
  }

  return Object.values(grouped);
}

  

}
